import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { NoticeEntity } from "../../Objects/Notice/NoticeEntity"
import { DeleteRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"

export const useRemoveNotice = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleRemove = async (notice: NoticeEntity, onSuccess: any) => {
    try {
      enableLoad()

      const response = await DeleteRequest(`${API_ROUTES.NOTICE.DELETE}/${notice.id}`)

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
